import type React from 'react';
import type { ReactElement } from 'react';
import { connect } from 'react-redux';

import { thousandSeparated } from 'shared/util/formatting';
import type { PaleState } from '../../interfaces';

export interface Counter {
    numberOfHotels: number;
}

export const ResultCount: React.FC<Counter> = ({ numberOfHotels }): ReactElement<Counter> => (
    <output className="u-no-break" data-testid="resultCount">
        <span className="u-strong">{numberOfHotels ? thousandSeparated(numberOfHotels) : '0'}</span> ulike hoteller
    </output>
);

const mapStateToProps = (state: PaleState): Counter => ({
    numberOfHotels: state.results.numberOfHotels,
});

export default connect(mapStateToProps)(ResultCount);
